import { ReactNode } from "react";
import AbstractDoc from "../AbstractDoc";

export default class Privacy_en
    extends AbstractDoc {

    protected getDoc(): ReactNode {
        return (
            <div>
                <h1>Privacy Policy</h1>

                <p>Effective Date: 2023-08-23</p>

                <p>PlayReverser ("We," "Our," "Us") is committed to protecting and respecting your privacy. With this privacy policy, we intend to inform you about how we collect, use, and protect your personal information in relation to the "CandyKu Sudoku" application ("App").</p>

                <h2>Collection and Use of Information</h2>

                <h3>Personal Data</h3>

                <p>Our App does not directly collect personally identifiable information from the user.</p>

                <h3>Data Collection from Third Parties</h3>

                <p>Our App uses the following third-party services that may collect information used to identify you as a user:</p>

                <ul>
                    <li><strong>Firebase:</strong> We use Firebase Analytics to collect data on App usage, including device identifier data. Firebase is provided by Google, and their privacy policy is available at <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>.</li>
                    <li><strong>AdMob:</strong> We use Google's AdMob for in-App advertising. AdMob may collect user data for ad personalization. AdMob's privacy policy is available at <a href="https://support.google.com/admob/answer/6128543?hl=en">https://support.google.com/admob/answer/6128543?hl=en</a>.</li>
                    <li><strong>Unity:</strong> Our App may utilize the Unity game engine, which may collect user data. Unity's privacy policy is available at <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>.</li>
                </ul>

                <h2>Information Disclosure</h2>

                <p>We do not sell, market, or otherwise transfer your personal information to third parties without your consent.</p>

                <h2>Security</h2>

                <p>We implement reasonable measures to protect personal information from unauthorized access or disclosure.</p>

                <h2>Changes to this Privacy Policy</h2>

                <p>This privacy policy may be updated periodically to reflect any changes in our data collection and usage practices. When changes are made, the "Effective Date" at the top of the privacy policy will be updated. We recommend checking this page periodically to stay informed about how we are protecting your information.</p>

                <h2>Contact Us</h2>

                <p>For questions about our privacy policy, please contact us at:</p>

                <p>playreverser@gmail.com</p>
            </div>
        );
    }

}